import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxDataGridModule,
    DxFormComponent,
    DxFormModule,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { Month, ProductivitySettingGridViewDto } from '@services';
import EnumUtils from '../../../shared/enum-utils';
import { FilterPanelComponent } from '../../../components/library/filter-panel/filter-panel.component';
import { CapitalCasePipe } from '../../../pipes/capital-case.pipe';
import { FilterConfig, GridPageComponent} from '../../common/grid-page.component';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';

@Component({
    selector: 'app-productivity-settings',
    imports: [
        CommonModule,
        CapitalCasePipe,
        DxDataGridComponent,
        DxiColumnComponent,
        DxoHeaderFilterComponent,
        DxoScrollingComponent,
        DxButtonComponent,
        DxTemplateDirective,
        DxiItemComponent,
        DxDataGridModule,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoFilterRowComponent,
        DxFormComponent,
        FilterPanelComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        DxFormModule,
    ],
    templateUrl: './productivity-settings.component.html',
})
export class ProductivitySettingsComponent extends GridPageComponent<ProductivitySettingGridViewDto> {
    @ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;

    protected override exportName: string = 'ProductivitySettings Report';
    protected offset: number = 100;
    public dateTimeFormat = DATE_TIME_FORMAT;
    public minYear = new Date().getFullYear();
    public maxYear = this.minYear + 20;

    dataSource = this.dataSources.productivitySettings();
    monthOptions = EnumUtils.getEnumOptions(Month);

    protected override filterConfig: FilterConfig[] = [
        { field: 'month', op: '=' },
        { field: 'year', op: 'contains' },
        { field: 'value', op: 'contains' },
        { field: 'created', op: '>='},
    ];

    constructor() {
        super();
        this.init(ProductivitySettingGridViewDto);
    }

    addNew() {
        this.grid.instance.addRow();
    }

    onRowUpdating(e: any) {
        e.newData = Object.assign({}, e.oldData, e.newData);
    }

    onRowDblClick(e: any) {
        if (e.rowType === "data") {
            e.component.editRow(e.rowIndex);
        }
    }
}
